import "./main.scss";
import "swiper/css";
import htmx from "htmx.org";
htmx.config.scrollIntoViewOnBoost = false;
import "./js/alpine";
import "./js/modal";
